import { ProcessPathState, ValidationErrors } from 'src/pages/settings/tabs/siteLayout/types';

/**
 * Validates the entire SiteLayout state before save.
 * Returns an object mapping field paths to error messages.
 * Returns empty object if all validations pass.
 */
export function validateSiteLayout(processPaths: ProcessPathState[]): ValidationErrors {
  const errors: ValidationErrors = {};

  // Check for duplicate process paths. A process path is uniquely identified by
  // its processId + functionId, so multiple functions may share a processId.
  const processPathKeys = new Set<string>();

  for (let ppIdx = 0; ppIdx < processPaths.length; ppIdx++) {
    const pp = processPaths[ppIdx];
    const ppKey = `processPaths[${ppIdx}]`;
    const uniqueKey = `${pp.processId}-${pp.functionId}`;

    // Duplicate process path check
    if (processPathKeys.has(uniqueKey)) {
      errors[`${ppKey}.processId`] = 'Duplicate process path';
    }
    processPathKeys.add(uniqueKey);

    if (pp.staffingMode === 'PROCESS_LINES') {
      // Validate lines
      for (let lineIdx = 0; lineIdx < pp.lines.length; lineIdx++) {
        const line = pp.lines[lineIdx];
        const lineKey = `${ppKey}.lines[${lineIdx}]`;

        if (!line.lineName || line.lineName.trim() === '') {
          errors[`${lineKey}.lineName`] = 'Line name is required';
        }

        // Validate workstation IDs are non-empty
        for (let wsIdx = 0; wsIdx < line.workstations.length; wsIdx++) {
          if (!line.workstations[wsIdx].workstationId || line.workstations[wsIdx].workstationId.trim() === '') {
            errors[`${lineKey}.workstations[${wsIdx}].workstationId`] = 'Workstation ID is required';
          }
        }
      }
    } else if (pp.staffingMode === 'DEPARTMENT') {
      // Validate individual workstation IDs are non-empty
      for (let wsIdx = 0; wsIdx < pp.individualWorkstations.length; wsIdx++) {
        if (!pp.individualWorkstations[wsIdx].workstationId || pp.individualWorkstations[wsIdx].workstationId.trim() === '') {
          errors[`${ppKey}.individualWorkstations[${wsIdx}].workstationId`] = 'Workstation ID is required';
        }
      }
    }
  }

  return errors;
}
